import { render, staticRenderFns } from "./CreateSPRPage.vue?vue&type=template&id=fb2c3e42&scoped=true&"
import script from "./CreateSPRPage.vue?vue&type=script&lang=js&"
export * from "./CreateSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateSPRPage.vue?vue&type=style&index=0&id=fb2c3e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2c3e42",
  null
  
)

export default component.exports